import {formatInTimeZone} from "date-fns-tz";
import {ResolutionTools} from "./ResolutionTools";


export class ResolutionDateTime extends ResolutionTools {

    public static getDateFromMinutes(minutes: number): Date {
        minutes = Math.floor(minutes);
        return (new Date(minutes * 1000 * 60));
    }

    public static getDateStringFromMinutes(minutes: number): string {
        // should be YYYY-MM-DD HH:mm
        return this.getDateFromMinutes(minutes).toISOString().substring(0, 16).replace('T', ' ');
    }

    public static getMinutesForToday(): number {
        return this.getMinutesFromDate(new Date());
    }

}